module.exports = __webpack_public_path__ + "img/player1.ce5cb9eb.png";